import '../index.css';
import '../styles/Experience.css';
import React from 'react';

export default function Experience() {
  return (
    <div className="experience-container py-10 px-6">
      <h1 className="text-3xl font-bold text-center text-white mb-8 mt-0">Experience</h1>
      <ol className="relative border-s border-gray-600">
        <li className="mb-10 ms-6">
          <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full -start-3 ring-8 ring-gray-800">
            <svg
              className="w-2.5 h-2.5 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
          </span>
          <h3 className="flex items-center mb-1 text-lg font-semibold text-white">
            California Connections Academy
          </h3>
          <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
            2018 - 2022
          </time>
          <p className="mb-4 text-base font-normal text-gray-400">
            High School Diploma, 4.0 GPA, 21 AP Credits, AP Scholar with Distinction, 2019 Ripon Student of the Year.
          </p>
        </li>
        <li className="mb-10 ms-6">
          <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full -start-3 ring-8 ring-gray-800">
            <svg
              className="w-2.5 h-2.5 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 1 0 0-2Z" />
            </svg>
          </span>
          <h3 className="mb-1 text-lg font-semibold text-white">AI Research Engineer</h3>
          <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
            2020 - 2022
          </time>
          <p className="text-base font-normal text-gray-400">
            Inspirit AI, Stanford. Collaborated with Stanford & MIT PhDs to train advanced computer vision models in healthcare and accessibility.
          </p>
        </li>
        <li className="mb-10 ms-6">
          <span className="absolute flex items-center justify-center w-6 h-6 bg-yellow-500 rounded-full -start-3 ring-8 ring-gray-800">
            <svg
              className="w-2.5 h-2.5 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
          </span>
          <h3 className="mb-1 text-lg font-semibold text-white">University of California, Los Angeles</h3>
          <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
            2022 - Present
          </time>
          <p className="text-base font-normal text-gray-400">Bachelor of Science in Computer Science.</p>
        </li>
        <li className="mb-10 ms-6">
          <span className="absolute flex items-center justify-center w-6 h-6 bg-yellow-500 rounded-full -start-3 ring-8 ring-gray-800">
            <svg
              className="w-2.5 h-2.5 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
          </span>
          <h3 className="mb-1 text-lg font-semibold text-white">Head of Engineering & AI</h3>
          <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
            2023 - Present
          </time>
          <p className="text-base font-normal text-gray-400">
            Elegant Mind Lab @ UCLA. Spearheaded numerous multi-disciplinary GenAI projects utilizing Vision Transformers & LLMs.
          </p>
        </li>
        <li className="mb-10 ms-6">
          <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full -start-3 ring-8 ring-gray-800">
            <svg
              className="w-2.5 h-2.5 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 1 0 0-2Z" />
            </svg>
          </span>
          <h3 className="mb-1 text-lg font-semibold text-white">SAP iXP Software Developer Intern</h3>
          <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
            October 2024 - Present
          </time>
          <p className="text-base font-normal text-gray-400">
            Working on MLE solutions for SAP Labs BTP Innovation.
          </p>
        </li>
        <li className="ms-6">
          <span className="absolute flex items-center justify-center w-6 h-6 bg-gray-500 rounded-full -start-3 ring-8 ring-gray-800">
            <svg
              className="w-2.5 h-2.5 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
          </span>
          <h3 className="mb-1 text-lg font-semibold text-white">What&apos;s Next?</h3>
          <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
            Present - ???
          </time>
          <p className="text-base font-normal text-gray-400"></p>
        </li>
      </ol>
    </div>
  );
}
